import * as rangy from 'rangy';
import 'rangy/lib/rangy-textrange';
var EXCLUDING_TAG_NAMES = ['STYLE', 'SVG'];
var NodeHelper = /** @class */ (function () {
    function NodeHelper(options) {
        this.options = options;
    }
    NodeHelper.prototype.isExcludedNode = function (node) {
        var _a, _b;
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return false;
        }
        if (EXCLUDING_TAG_NAMES.indexOf(node.tagName) !== -1) {
            return true;
        }
        if ((_b = (_a = this.options).EXCLUDE_ELEMENT_FILTER) === null || _b === void 0 ? void 0 : _b.call(_a, node)) {
            return true;
        }
        return false;
    };
    NodeHelper.prototype.getTextContent = function (node) {
        var _this = this;
        var _a;
        if (this.isExcludedNode(node)) {
            return '';
        }
        switch (node.nodeType) {
            case Node.DOCUMENT_FRAGMENT_NODE:
            case Node.ELEMENT_NODE: {
                var text = '';
                var treeWalker = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.createTreeWalker(node, NodeFilter.SHOW_ALL, {
                    acceptNode: function (node) {
                        return _this.isExcludedNode(node)
                            ? NodeFilter.FILTER_REJECT
                            : NodeFilter.FILTER_ACCEPT;
                    },
                });
                if (treeWalker) {
                    while (treeWalker.nextNode()) {
                        if (treeWalker.currentNode.nodeType === Node.TEXT_NODE ||
                            treeWalker.currentNode.nodeType === Node.CDATA_SECTION_NODE) {
                            text += treeWalker.currentNode.nodeValue;
                        }
                    }
                }
                return text;
            }
            case Node.ATTRIBUTE_NODE: {
                return node.value;
            }
            case Node.TEXT_NODE:
            case Node.CDATA_SECTION_NODE: // CDATASection is a subclass of Text
            case Node.PROCESSING_INSTRUCTION_NODE:
            case Node.COMMENT_NODE: {
                return node.data;
            }
            default: {
                return null;
            }
        }
    };
    NodeHelper.prototype.getNodes = function (first, last, sliceFirstLast) {
        if (sliceFirstLast === void 0) { sliceFirstLast = false; }
        if (!first || !last) {
            return [];
        }
        if (first.get) {
            first = first.get(0);
        }
        if (last.get) {
            last = last.get(0);
        }
        if (!first.nodeName || !last.nodeName) {
            return [];
        }
        var e = first;
        var result = [];
        while (e !== last) {
            result.push(e);
            var next = void 0;
            if (e.childNodes.length > 0) {
                next = e.childNodes[0];
            }
            else {
                next = e.nextSibling || this.getUncle(e);
            }
            if (next) {
                e = next;
                continue;
            }
            break;
        }
        result.push(last);
        if (sliceFirstLast) {
            return result.slice(1, -1);
        }
        return result;
    };
    NodeHelper.prototype.getParentNodes = function (el, tag, attr) {
        var n = [];
        while (el) {
            if (el.tagName === tag && el.hasAttribute(attr)) {
                n.push(el);
            }
            el = el.parentNode;
        }
        return n;
    };
    NodeHelper.prototype.getUncle = function (e) {
        var parent = e.parentNode;
        if (parent) {
            var next = parent.nextSibling;
            if (next) {
                return next;
            }
            return this.getUncle(parent);
        }
        return null;
    };
    NodeHelper.prototype.getOlderBrotherOrUncle = function (e, parentStop) {
        if (e.previousSibling) {
            return e.previousSibling;
        }
        var parent = e.parentNode;
        if (parent) {
            if (parent === parentStop) {
                return null;
            }
            var prev = parent.previousSibling;
            if (prev) {
                return prev;
            }
            return this.getOlderBrotherOrUncle(parent, parentStop);
        }
        return null;
    };
    /* fillStartOrEnd
     * true : fillStart
     * false : fillEnd
     * undefined : with Spaces
     */
    NodeHelper.prototype.nodeByOffset = function (el, offset, fallback, fillStartOrEnd) {
        var characterOnly = fillStartOrEnd !== undefined;
        var index = 0;
        for (var i = 0; i < el.childNodes.length; i++) {
            var ch = el.childNodes[i];
            var textContent = this.getTextContent(ch);
            if (textContent) {
                if (index + this.getTextLength(textContent, characterOnly) > offset ||
                    (fallback &&
                        index + this.getTextLength(textContent, characterOnly) >= offset)) {
                    if (ch.nodeType === Node.TEXT_NODE) {
                        var nodeOffset = offset - index;
                        var realOffset = nodeOffset;
                        if (fillStartOrEnd === true) {
                            var m = 0, n = void 0, o = 0;
                            while ((n = this.getTextLength(textContent.substring(0, realOffset), characterOnly)) <= nodeOffset) {
                                if (m === n) {
                                    o++;
                                    if (o > 30) {
                                        break;
                                    }
                                }
                                else {
                                    o = 0;
                                }
                                m = n;
                                realOffset++;
                                if (this.getTextLength(textContent.substring(0, realOffset), characterOnly) > nodeOffset) {
                                    realOffset--;
                                    break;
                                }
                                if (realOffset > textContent.length) {
                                    break;
                                }
                            }
                        }
                        else if (fillStartOrEnd === false) {
                            while (this.getTextLength(textContent.substring(0, realOffset), characterOnly) <= nodeOffset) {
                                if (this.getTextLength(textContent.substring(0, realOffset), characterOnly) > nodeOffset) {
                                    break;
                                }
                                realOffset++;
                                if (realOffset > textContent.length) {
                                    break;
                                }
                            }
                        }
                        /* else if (fillStartOrEnd === undefined) {}*/
                        return {
                            textNode: ch,
                            offset: realOffset,
                        };
                    }
                    return this.nodeByOffset(ch, offset - index, fallback, fillStartOrEnd);
                }
                index += this.getTextLength(textContent, characterOnly);
            }
        }
        if (!fallback) {
            return this.nodeByOffset(el, offset, true, fillStartOrEnd);
        }
        return null;
    };
    NodeHelper.prototype.getOffset = function (parent, node, offset, characterOnly) {
        if (characterOnly === void 0) { characterOnly = false; }
        if (characterOnly && !this.isExcludedNode(node)) {
            // if (characterOnly) {
            offset = this.getTextLength((this.getTextContent(node) || '').substring(0, offset), characterOnly);
        }
        var previousSibling = this.getOlderBrotherOrUncle(node, parent);
        while (previousSibling) {
            var textContent = this.getTextContent(previousSibling);
            if (textContent) {
                offset += this.getTextLength(textContent, characterOnly);
            }
            previousSibling = this.getOlderBrotherOrUncle(previousSibling, parent);
        }
        return offset;
    };
    NodeHelper.prototype.getTextLength = function (textContent, characterOnly) {
        return characterOnly
            ? textContent.replace(/\s+/g, '').length
            : textContent.length;
    };
    NodeHelper.prototype.findClosestParentNode = function (element, predicate) {
        do {
            if (predicate(element)) {
                return element;
            }
        } while ((element = element && element.parentNode));
        return null;
    };
    return NodeHelper;
}());
export { NodeHelper };
var Highlighter = /** @class */ (function () {
    function Highlighter(opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        this.options = Object.assign({
            ATTR_HIGHLIGHT_ID: 'highlight-id',
            BODY_ID: '_',
            BODY: undefined,
            CLASS_PREFIX: 'bukh-',
            EXCLUDE_ELEMENT_FILTER: undefined,
            ADDRESS_PATTERN: [
                /* [
                      pattern,
                      return function,
                      characterOnly
                      ],
                  */
                [
                    /^(\d+)-(\d+)$/,
                    function (m) {
                        return [
                            parseInt(m[1]) - 1 + '-' + (parseInt(m[2]) - 1),
                            _this.options.BODY_ID,
                            parseInt(m[1]) - 1,
                            _this.options.BODY_ID,
                            parseInt(m[2]) - 1,
                            true,
                        ];
                    },
                ],
                // [
                //   /^([^:]+):0:(\d+)~([^:]+):0:(\d+)$/,
                //   (m: any): any[] => {
                //     m.push(false);
                //     return m;
                //   },
                // ],
                // [
                //   /^([^:]+):(\d+)~([^:]+):(\d+)$/,
                //   (m: any): any[] => {
                //     m.push(false);
                //     return m;
                //   },
                // ],
                // [
                //   /^([^:]+:[^:]+):(\d+)~([^:]+:[^:]+):(\d+)$/,
                //   (m: any): any[] => {
                //     m.push(false);
                //     return m;
                //   },
                // ],
                // [
                //   /^(\d+)~(\d+)$/,
                //   (m: any): any[] => {
                //     return [
                //       m[0],
                //       this.options.BODY_ID,
                //       m[1],
                //       this.options.BODY_ID,
                //       m[2],
                //       false,
                //     ];
                //   },
                // ],
                [
                    /^([1-9]\d*)\.(\d{6,7})$/,
                    function (m) {
                        return [
                            m[0],
                            _this.options.BODY_ID,
                            m[1],
                            _this.options.BODY_ID,
                            '' + (parseInt(m[1]) + 1),
                            true,
                        ];
                    },
                ],
            ],
        }, opts);
        this.nodeHelper = new NodeHelper(this.options);
    }
    Highlighter.prototype.parseAddress = function (address) {
        var addressObject = {};
        this.options.ADDRESS_PATTERN.some(function (p) {
            var m = p[0].exec(address);
            if (m) {
                var o = p[1](m);
                addressObject = {
                    address: o[0],
                    startParent: o[1],
                    startOffset: o[2],
                    endParent: o[3],
                    endOffset: o[4],
                    characterOnly: o[5],
                };
                return true;
            }
            return false;
        });
        return addressObject;
    };
    Highlighter.prototype.getHighlightIdFromElement = function (element) {
        return element.getAttribute(this.options.ATTR_HIGHLIGHT_ID);
    };
    Highlighter.prototype.getHighlightIds = function (doc, start, startOffset, end, endOffset, characterOnly) {
        var highlightIds = [];
        var topContainer = this.getTopContainer(doc);
        var startContainer = (start && start.nodeType
            ? start
            : start === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(start));
        var endContainer = (end && end.nodeType
            ? end
            : end === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(end));
        var startNode = this.nodeHelper.nodeByOffset(startContainer, startOffset, undefined, characterOnly);
        var endNode = this.nodeHelper.nodeByOffset(endContainer, endOffset, undefined, characterOnly);
        if (!startNode || !endNode) {
            return highlightIds;
        }
        var startTextNode = startNode.textNode;
        var endTextNode = endNode.textNode;
        var nodes = this.nodeHelper.getNodes(startTextNode, endTextNode);
        var dic = {};
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            var parents = this.nodeHelper.getParentNodes(node, 'X', this.options.ATTR_HIGHLIGHT_ID);
            for (var j in parents) {
                var p = parents[j];
                var hId = this.getHighlightIdFromElement(p);
                hId && (dic[hId] = true);
            }
        }
        for (var highlightId in dic) {
            highlightIds.push(highlightId);
        }
        return highlightIds;
    };
    Highlighter.prototype.wrap = function (doc, startNode, startOffset, endNode, endOffset, className, highlightId) {
        var range = doc.createRange();
        range.setStart(startNode, startOffset);
        range.setEnd(endNode, endOffset);
        try {
            range.surroundContents(this.createSpan(doc, className, highlightId));
        }
        catch (e) {
            console.log('highlight error');
        }
    };
    Highlighter.prototype.createSpan = function (doc, className, highlightId) {
        var span = doc.createElement('X');
        span.className = className;
        if (highlightId) {
            span.setAttribute(this.options.ATTR_HIGHLIGHT_ID, highlightId);
        }
        return span;
    };
    Highlighter.prototype.isRange = function (obj) {
        return obj instanceof Range || (!!obj.setStart && !!obj.setEnd);
    };
    Highlighter.prototype.getTopContainer = function (doc) {
        return this.options.BODY || doc.body;
    };
    Highlighter.prototype.getTextFromRange = function (range) {
        var _this = this;
        var fragment = range.cloneContents();
        var removeExcludedElement = function (node) {
            if (_this.nodeHelper.isExcludedNode(node)) {
                node.textContent = null;
                return;
            }
            for (var i = 0; i < node.childNodes.length; i++) {
                removeExcludedElement(node.childNodes[i]);
            }
        };
        removeExcludedElement(fragment);
        var newRange = new Range();
        newRange.selectNodeContents(fragment);
        return newRange.toString();
    };
    Highlighter.prototype.generateHighlightId = function () {
        return new Date().getTime().toString();
    };
    /**
     * @deprecated
     */
    Highlighter.prototype.getSelectionFromRange = function (doc, range) {
        var hId;
        var topContainer = this.getTopContainer(doc);
        var startParent = topContainer;
        var startOffset = this.nodeHelper.getOffset(startParent, range.startContainer, range.startOffset, true) + 1;
        var endParent = topContainer;
        var endOffset = this.nodeHelper.getOffset(endParent, range.endContainer, range.endOffset, true);
        var text = this.getTextFromRange(range);
        var hIds = this.getHighlightIds(doc, startParent, startOffset, endParent, endOffset, true);
        if (hIds.length === 1) {
            hId = hIds[0];
        }
        return {
            startParent: startParent,
            startOffset: startOffset,
            endParent: endParent,
            endOffset: endOffset,
            address: startOffset + '-' + endOffset,
            text: text,
            highlightId: hId !== null && hId !== void 0 ? hId : undefined,
            highlightIds: hIds,
        };
    };
    /**
     * @deprecated
     */
    Highlighter.prototype.getSelectionFromElement = function (doc, elem) {
        if (this.getHighlightIdFromElement(elem)) {
            return this.getSelectionFromHighlightElement(doc, elem);
        }
        var topContainer = this.getTopContainer(doc);
        var offset = this.nodeHelper.getOffset(topContainer, elem, 0, true);
        return {
            startParent: topContainer,
            endParent: topContainer,
            startOffset: offset,
            endOffset: offset,
            address: offset + '-' + offset,
            text: '',
        };
    };
    /**
     * @deprecated
     */
    Highlighter.prototype.getSelectionFromHighlightElement = function (doc, elem) {
        var _this = this;
        var hId = this.getHighlightIdFromElement(elem);
        if (!hId) {
            return null;
        }
        var text;
        var topContainer = this.getTopContainer(doc);
        var startContainer = doc.querySelector('x.' +
            this.options.CLASS_PREFIX +
            'start[' +
            this.options.ATTR_HIGHLIGHT_ID +
            "='" +
            hId +
            "']");
        var endContainer = doc.querySelector('x.' +
            this.options.CLASS_PREFIX +
            'end[' +
            this.options.ATTR_HIGHLIGHT_ID +
            "='" +
            hId +
            "']");
        var startOffset = this.nodeHelper.getOffset(topContainer, startContainer, 0, true) + 1;
        var endOffset = this.nodeHelper.getOffset(topContainer, endContainer, (function (n) {
            var offset = 0;
            for (var i = 0; i < n.childNodes.length; i++) {
                var textContent = _this.nodeHelper.getTextContent(n.childNodes[i]);
                if (textContent) {
                    offset += (textContent || '').length;
                }
            }
            return offset;
        })(endContainer), true);
        text = '';
        var xList = doc.querySelectorAll('x[' + this.options.ATTR_HIGHLIGHT_ID + "='" + hId + "']");
        for (var i = 0; i < xList.length; i++) {
            text += this.nodeHelper.getTextContent(xList[i]) + ' ';
        }
        var hIds = this.getHighlightIds(doc, topContainer, startOffset, topContainer, endOffset, true);
        return {
            startParent: topContainer,
            startOffset: startOffset,
            endParent: topContainer,
            endOffset: endOffset,
            address: startOffset + '-' + endOffset,
            text: text,
            highlightId: hId !== null && hId !== void 0 ? hId : undefined,
            highlightIds: hIds,
        };
    };
    Highlighter.prototype.select = function (doc, arg) {
        if (arg && this.isRange(arg)) {
            return this.getSelectionFromRange(doc, arg);
        }
        return this.getSelectionFromElement(doc, arg);
    };
    Highlighter.prototype.getOffset = function (parent, node, offset) {
        return this.nodeHelper.getOffset(parent, node, offset);
    };
    Highlighter.prototype.expandToWord = function (doc) {
        if (!doc.getSelection()) {
            return doc.getSelection();
        }
        var originalRange = doc.getSelection().getRangeAt(0);
        // rangy.getSelection(doc).ex
        rangy.getSelection(doc).expand('word', {
            wordOptions: {
                // wordRegex: /([\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf\u4e00-\u9fff\u3400-\u4dbf\u20000-\u2a6df\u2a700-\u2b73f\u2b740-\u2b81f\u2b820-\u2ceaf\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u2f800-\u2fa1f])|([^\s]+)/g,
                /* 일본어, 중국어는 띄어쓰기가 없어서 character하나를 word로 취급하고, 그 외의 언어는 공백 없는 characters를 word로 취급.. */
                wordRegex: /([\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff])|([^\s]+)/g,
            },
            // characterOptions: {
            //     ignoreCharacters: '\n'
            // },
            trim: true,
        });
        var newRange = doc.getSelection().getRangeAt(0);
        if (newRange.startContainer.nodeType === Node.ELEMENT_NODE &&
            newRange.startContainer !== originalRange.startContainer) {
            console.log('wrong expanding.. change range start!!');
            newRange.setStart(originalRange.startContainer, originalRange.startOffset);
        }
        if (newRange.endContainer.nodeType === Node.ELEMENT_NODE &&
            newRange.endContainer !== originalRange.endContainer) {
            console.log('wrong expanding.. change range end!!');
            newRange.setEnd(originalRange.endContainer, originalRange.endOffset);
        }
        return doc.getSelection();
    };
    Highlighter.prototype.highlight = function (doc, address, highlightClass, newHighlightId) {
        var _this = this;
        var _a;
        var a = this.parseAddress(address);
        var start = a.startParent;
        var startOffset = a.startOffset;
        var end = a.endParent;
        var endOffset = a.endOffset;
        var characterOnly = a.characterOnly;
        var topContainer = this.getTopContainer(doc);
        var startContainer = (start && start.nodeType
            ? start
            : start === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(start));
        var endContainer = (end && end.nodeType
            ? end
            : end === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(end));
        if (!startContainer || !endContainer) {
            return null;
        }
        if (!newHighlightId) {
            newHighlightId = this.generateHighlightId();
        }
        var startNode = this.nodeHelper.nodeByOffset(startContainer, startOffset, undefined, characterOnly ? true : undefined);
        var endNode = this.nodeHelper.nodeByOffset(endContainer, endOffset, undefined, characterOnly ? false : undefined);
        if (!startNode || !endNode) {
            return null;
        }
        var startTextNode = startNode.textNode;
        var endTextNode = endNode.textNode;
        startOffset = startNode.offset;
        endOffset = endNode.offset;
        var nodes = this.nodeHelper.getNodes(startTextNode, endTextNode, !!highlightClass);
        for (var i in nodes) {
            var targetNode = nodes[i];
            var eParent = this.nodeHelper.findClosestParentNode(targetNode, function (e) {
                return _this.nodeHelper.isExcludedNode(e);
            });
            if (eParent) {
                continue;
            }
            if (targetNode.nodeType === Node.TEXT_NODE &&
                targetNode.nodeValue.trim().length > 0) {
                this.wrap(doc, targetNode, 0, targetNode, targetNode.nodeValue.length, highlightClass, newHighlightId);
            }
        }
        //highlight start and end in same element
        if (startTextNode === endTextNode) {
            if (startTextNode.nodeType === Node.TEXT_NODE) {
                this.wrap(doc, startTextNode, startOffset, startTextNode, endOffset, highlightClass +
                    ' ' +
                    this.options.CLASS_PREFIX +
                    'start ' +
                    this.options.CLASS_PREFIX +
                    'end', newHighlightId);
            }
        }
        else {
            if (startTextNode.nodeType === Node.TEXT_NODE) {
                this.wrap(doc, startTextNode, startOffset, startTextNode, startTextNode.length, highlightClass + ' ' + this.options.CLASS_PREFIX + 'start', newHighlightId);
            }
            if (endTextNode.nodeType === Node.TEXT_NODE) {
                this.wrap(doc, endTextNode, 0, endTextNode, endOffset, highlightClass + ' ' + this.options.CLASS_PREFIX + 'end', newHighlightId);
            }
        }
        (_a = doc.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        return newHighlightId;
    };
    Highlighter.prototype.remove = function (doc, highlightId) {
        var _this = this;
        if (typeof highlightId === 'string') {
            highlightId = [highlightId];
        }
        var topContainer = this.getTopContainer(doc);
        highlightId.forEach(function (id) {
            var highlights = topContainer.querySelectorAll('x[' + _this.options.ATTR_HIGHLIGHT_ID + "='" + id + "']");
            for (var i = 0; i < highlights.length; i++) {
                highlights[i].outerHTML = highlights[i].innerHTML;
            }
        });
    };
    Highlighter.prototype.change = function (doc, highlightId, newClassName, oldClassName) {
        var topContainer = this.getTopContainer(doc);
        var highlights = topContainer.querySelectorAll('x[' + this.options.ATTR_HIGHLIGHT_ID + "='" + highlightId + "']");
        for (var i = 0; i < highlights.length; i++) {
            highlights[i].classList.remove(oldClassName);
            highlights[i].classList.add(newClassName);
        }
    };
    Highlighter.prototype.createSelectorString = function (hId, className) {
        var result = 'x';
        if (hId != null) {
            result += '[' + this.options.ATTR_HIGHLIGHT_ID + "='" + hId + "']";
        }
        if (className) {
            if (Array.isArray(className)) {
                className = className.join('.');
            }
            result += '.' + className;
        }
        return result;
    };
    Highlighter.prototype.getRangeFromAddress = function (doc, address) {
        var parsed = this.parseAddress(address);
        var start = parsed.startParent;
        var startOffset = parsed.startOffset;
        var end = parsed.endParent;
        var endOffset = parsed.endOffset;
        // characterOnly = true;
        var topContainer = this.getTopContainer(doc);
        var startContainer = (start && start.nodeType
            ? start
            : start === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(start));
        var endContainer = (end && end.nodeType
            ? end
            : end === this.options.BODY_ID
                ? topContainer
                : doc.getElementById(end));
        if (!startContainer || !endContainer) {
            return null;
        }
        var startNode = this.nodeHelper.nodeByOffset(startContainer, startOffset, undefined, true);
        var endNode = this.nodeHelper.nodeByOffset(endContainer, endOffset, undefined, false);
        if (!startNode || !endNode) {
            return null;
        }
        var startTextNode = startNode.textNode;
        var endTextNode = endNode.textNode;
        startOffset = startNode.offset;
        endOffset = endNode.offset;
        var range = doc.createRange();
        range.setStart(startTextNode, startOffset);
        range.setEnd(endTextNode, endOffset);
        return range;
    };
    return Highlighter;
}());
export { Highlighter };
